<template>
  <div>
    <v-card class="pa-3 rounded_max" elevation="1">
      <v-row no-gutters>
        <v-col cols="12">
          <div class="pa-3">
            <p class="default_txt">Source</p>
            <v-select
              dense
              hide-details
              :disabled="selectedData ? true : false"
              :items="listSource"
              item-text="txt"
              item-value="val"
              v-model="content.source"
              placeholder="Category Course"
              :color="color"
            ></v-select>
          </div>
        </v-col>
        <v-col cols="12">
          <!-- LIST MATERI -->
          <div class="pa-3" v-if="content.source == 'materi'">
            <div
              class="d-flex align-center justify-center flex-column"
              v-if="!selectedData"
            >
              <img
                src="../../../../assets/img/gundam/noMterial.png"
                height="150px"
                alt=""
              />
              <b class="default_txt my-3">Select material for your module</b>
              <v-btn
                class="text-capitalize rounded-lg"
                depressed
                dark
                :color="color"
                @click="selectMaterial"
                >Select</v-btn
              >
            </div>
            <div v-if="selectedData">
              <p class="default_txt">Data</p>
              <v-card
                elevation="1"
                class="d-flex mt-2"
                style="overflow: hidden"
              >
                <div class="strip" :style="`background: ${color}`"></div>
                <div class="pa-2 ml-3">
                  <h3 v-snip="3">{{ selectedData.name }}</h3>
                  <p class="default_txt">{{ selectedData.type_content }}</p>
                </div>
              </v-card>
            </div>
          </div>
          <!-- LIST GUDANG BELAJAR -->
        <div class="pa-3" v-else>
            <div
              class="d-flex align-center justify-center flex-column"
              v-if="!selectedData"
            >
              <img
                src="../../../../assets/img/gundam/noGB.png"
                height="150px"
                alt=""
              />
              <b class="default_txt my-3">Select Gudang Belajar</b>
              <v-btn
                class="text-capitalize rounded-lg"
                depressed
                dark
                :color="color"
                @click="selectGb"
                >Select</v-btn
              >
            </div>
            <div v-if="selectedData">
              <p class="default_txt">Data</p>
              <v-card
                elevation="1"
                class="d-flex mt-2"
                style="overflow: hidden"
              >
                <div class="strip" :style="`background: ${color}`"></div>
                <div class="pa-2 ml-3">
                  <h3 v-snip="3">{{ selectedData.name }}</h3>
                  <p class="default_txt">{{ selectedData.cat_gudang }}</p>
                </div>
              </v-card>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-overlay :absolute="true" color="white" opacity="1" :value="loading">
        <v-progress-circular
          indeterminate
          class="mr-2"
          color="#006341"
        ></v-progress-circular>
        <b class="color_default">Loading...</b>
      </v-overlay>
    </v-card>
    <div class="d-flex justify-end mt-4" v-if="selectedData">
      <v-btn
        v-if="!loading"
        class="text-capitalize rounded-lg mr-3"
        outlined
        dark
        :color="color"
        @click="selectedData = null"
        >Cancel</v-btn
      >
      <v-btn
        v-if="!loading"
        class="text-capitalize rounded-lg px-5"
        depressed
        dark
        :color="color"
        @click="assignMaterial"
        >Save</v-btn
      >
      <v-btn
        v-if="loading"
        :class="` text-capitalize rounded-lg`"
        depressed
        dark
        :color="color"
        >Saving</v-btn
      >
    </div>

    <div class="pa-2">
      <dialog-medium
        :d_create="d_create"
        @refetch="$emit('refetch')"
        @close="d_create = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
      <dialog-large
        :d_large="d_large"
        @selectItem="gotIt"
        @close="d_large = false"
        @create="createMaterial"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
    </div>
  </div>
</template>

<script>
// import DialogLarge from "../../../dialog/dialogLarge.vue";
// import dialogMedium from "../../../dialog/dialogMedium.vue";
export default {
  components: { 
    // dialogMedium,
    //  DialogLarge 
     },
  name: "formMaterial",
  data() {
    return {
      d_create: false,
      d_large: false,
      d_type: "",
      d_title: "",
      selectedData: null,
      inventory: null,
      loading: false,
      loadingGb: false,
      dataSet: null,
      getAway: false,
      listSource: [
        { txt: "Material", val: "materi" },
        { txt: "Gudang Belajar", val: "gudang_belajar" },
      ],
      dataGb: null,
      find: "",
      loading: false,
      showData: [5, 10, 20],
      limit: 10,
      page: 1,
      err: "",
      content: {
        source: "materi",
      },
    };
  },
  props: ["color", "module"],
  mounted() {},
  methods: {
    gotIt(item) {
      this.selectedData = item;
    },

    selectGb() {
      this.d_type = "s_gb";
      this.d_title = "Gudang Belajar";
      this.module["color"] = this.color;
      this.inventory = this.module;
      this.d_large = true;
    },
    selectMaterial() {
      this.d_type = "s_material";
      this.d_title = "Material";
      this.module["color"] = this.color;
      this.inventory = this.module;
      this.d_large = true;
    },
    createMaterial() {
      this.d_type = "c_material";
      this.d_title = "Material";
      this.inventory = this.module;
      this.d_create = true;
    },

    assignMaterial() {
      this.loading = true;
      this.err = "";
      let body = {
        course_materi_id: this.module.id,
        instance_id: this.selectedData.id,
        source: this.content.source,
      };
      let data = {
        path: `manage/material/store`,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then(() => {
          this.$emit("refetch", true);
          this.question = "";
          this.selectedData = null;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.strip {
  padding: 3px;
  width: 10px;
  max-height: 100%;
  border-radius: 0 !important;
}
</style>
